import "./ServiceAreas.module.css";
import Header from "@/reusable_sections/Header";
import GarageHero from "./sections/GarageHero";
import GarageServices from "./sections/GarageServices";
import GarageSearch from "./sections/GarageSearch";
import Areaswhylocal from "./sections/Areaswhylocal";
import GaragePartners from "./sections/GaragePartners";
import Testimonials from "./sections/Testimonials";
import GarageFaq from "./sections/GarageFaq";
import GarageService from "./sections/GarageService";
import SiteFooter from "./sections/SiteFooter";
export default function ServiceAreasPage() {
  return <div>
      <Header />
      <GarageHero />
      <GarageServices />
      <GarageSearch />
      <Areaswhylocal />
      <GaragePartners />
      <Testimonials />
      <GarageFaq />
      <GarageService />
      <SiteFooter />
    </div>;
}